import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../../../theme/modern/tokens"
import {COARSE, TOUCH_MIN} from "../../../../../theme/modern/touchTargets"

/**
 * Ported from the prototype's `.clinical-overlay` / `.clinical-card` /
 * `.meta-row` rules in pages/Record/record.css.
 *
 * NOTE: every `gap` is written as a px STRING. JSS 10.1.1 (what MUI v4 ships)
 * has no default unit for the plain `gap` property, so `gap: 16` would emit
 * `gap: 16` — invalid CSS, silently dropped.
 */
export default makeStyles((theme: ModernTheme) => ({
    overlay: {
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 200,
        background: theme.modern.overlayBg,
        display: "flex",
        justifyContent: "center",
        padding: 24,
        overflowY: "auto",
        animation: "$overlaypop .16s ease",

        "@media (max-width:640px)": {
            padding: 12,
        },
    },
    "@keyframes overlaypop": {
        from: {opacity: 0},
        to: {opacity: 1},
    },
    card: {
        background: theme.modern.panel,
        border: `1px solid ${theme.modern.line}`,
        borderRadius: 12,
        boxShadow: theme.modern.shadow,
        padding: "16px 18px 12px",
        minWidth: 360,
        maxWidth: 440,
        width: "100%",
        margin: "auto",

        "@media (max-width:640px)": {minWidth: 0},
    },
    card_head: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 10,
    },
    microlabel: {
        font: `600 10px/1 ${theme.modern.sans}`,
        letterSpacing: ".12em",
        textTransform: "uppercase",
        color: theme.modern.accent,
        background: theme.modern.accentSoft,
        borderLeft: `3px solid ${theme.modern.accent}`,
        padding: "5px 10px",
        borderRadius: "0 4px 4px 0",
    },
    close: {
        width: 24,
        height: 24,
        display: "grid",
        placeItems: "center",
        borderRadius: 6,
        color: theme.modern.ink3,
        fontSize: 17,
        lineHeight: 1,
        border: "none",
        background: "none",
        cursor: "pointer",

        "&:hover": {
            background: theme.modern.line2,
            color: theme.modern.ink,
        },
        "&:active": {background: theme.modern.line},

        // dismissing a dialog on a 24 px target, with the trace hidden behind it
        [COARSE]: {width: TOUCH_MIN, height: TOUCH_MIN},
    },
    meta_row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "16px",
        padding: "8px 4px",
        borderBottom: `1px solid ${theme.modern.line2}`,

        "&:last-child": {borderBottom: "none"},
    },
    meta_label: {
        font: `500 11.5px ${theme.modern.sans}`,
        color: theme.modern.ink2,
        textTransform: "uppercase",
        letterSpacing: ".06em",
    },
    meta_val: {
        font: `600 13px ${theme.modern.mono}`,
        color: theme.modern.ink,
        textAlign: "right",
    },
    meta_val__yes: {
        color: theme.modern.warn,
    },
    meta_val__no: {
        color: theme.modern.ink3,
    },
    meta_val__note: {
        font: `italic 400 12.5px ${theme.modern.sans}`,
        color: theme.modern.ink2,
    },
}))
